var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinsStacked02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 4.167c0 .92-2.052 1.666-4.584 1.666-2.531 0-4.583-.746-4.583-1.666m9.167 0c0-.92-2.052-1.667-4.584-1.667-2.531 0-4.583.746-4.583 1.667m9.167 0V7.88c-1.018.306-1.667.768-1.667 1.286m-7.5-5v10c0 .92 2.052 1.666 4.583 1.666 1.108 0 2.125-.143 2.917-.38V9.166M2.167 7.5c0 .92 2.052 1.667 4.583 1.667 1.108 0 2.125-.143 2.917-.381m-7.5 2.047c0 .92 2.052 1.667 4.583 1.667 1.108 0 2.125-.143 2.917-.381m9.167-2.952c0 .92-2.052 1.666-4.584 1.666-2.531 0-4.583-.746-4.583-1.666m9.167 0c0-.92-2.052-1.667-4.584-1.667-2.531 0-4.583.746-4.583 1.667m9.167 0v6.666c0 .92-2.052 1.667-4.584 1.667-2.531 0-4.583-.746-4.583-1.667V9.167m9.167 3.333c0 .92-2.052 1.667-4.584 1.667-2.531 0-4.583-.746-4.583-1.667",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsStacked02);
export default __webpack_public_path__ + "static/media/coinsStacked02.87dc33e72355ab54dd1e34dd80ab041f.svg";
export { ForwardRef as ReactComponent };